<template>
    <div class="container-fluid container-xl">
        <div class="row">
            <nav class="nav">
                <router-link
                    :to="{ path: '/' }"
                    exact-path
                    class="nav__item"
                    active-class="nav__item-active"
                >
                    <span class="d-none d-lg-inline-block nav__item__text">
                        Lượt Xổ Hôm Nay
                    </span>
                    <span class="d-inline-block d-lg-none nav__item__text">
                        Hôm Nay
                    </span>
                </router-link>
                <router-link
                    :to="{ name: 'north' }"
                    class="nav__item"
                    active-class="nav__item-active"
                >
                    <span class="d-none d-lg-inline-block nav__item__text">
                        Đánh Đề Miền Bắc
                    </span>
                    <span class="d-inline-block d-lg-none nav__item__text">
                        Miền Bắc
                    </span>
                </router-link>
                <router-link
                    :to="{ name: 'central' }"
                    class="nav__item"
                    active-class="nav__item-active"
                >
                    <span class="d-none d-lg-inline-block nav__item__text">
                        Đánh Đề Miền Trung
                    </span>
                    <span class="d-inline-block d-lg-none nav__item__text">
                        Miền Trung
                    </span>
                </router-link>
                <router-link
                    :to="{ name: 'south' }"
                    class="nav__item"
                    active-class="nav__item-active"
                >
                    <span class="d-none d-lg-inline-block nav__item__text">
                        Đánh Đề Miền Nam
                    </span>
                    <span class="d-inline-block d-lg-none nav__item__text">
                        Miền Nam
                    </span>
                </router-link>
                <router-link
                    :to="{ name: 'result' }"
                    class="nav__item"
                    active-class="nav__item-active"
                >
                    <span class="d-none d-lg-inline-block nav__item__text">
                        Dò Kết Quả
                    </span>
                    <span class="d-inline-block d-lg-none nav__item__text">
                        Dò kết quả
                    </span>
                </router-link>
                <router-link
                    v-if="token && inPage"
                    :to="{ name: 'history' }"
                    class="nav__item"
                    active-class="nav__item-active"
                >
                    <span class="d-none d-lg-inline-block nav__item__text">
                        Lịch sử cược
                    </span>
                    <span class="d-inline-block d-lg-none nav__item__text">
                        Lịch sử
                    </span>
                </router-link>
            </nav>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            token: 'userModule/token',
            inPage: 'userModule/inPage',
        }),
    },
};
</script>

<style lang="scss">
@import './Nav';
</style>
